import * as ng from 'angular';

import { ApiHelperService } from '../../shared';

export class CampaignsApi {
   static $inject = ['apiHelper'];

   constructor(private apiHelper:ApiHelperService) { }

   list(brandId:number) {
      return this.apiHelper.get(`campaigns?brandId=${brandId}`);
   }

   get(id:number) {
      return this.apiHelper.get(`campaigns/${id}`);
   }

   create(campaign) {
      return this.apiHelper.post('campaigns', campaign);
   }

   update(campaign) {
      return this.apiHelper.post(`campaigns/${campaign.id}`, campaign);
   }

   del(id:number, force:boolean = false) {
      return this.apiHelper.del(`campaigns/${id}?force=${force}`);
   }

   copyYouTube(fromId:number, toId:number) {
      return this.apiHelper.post(`campaigns/${toId}/copyYouTube/${fromId}`, {});
   }

   disconnectYouTube(id:number) {
      return this.apiHelper.post('campaigns/' + id + '/disconnectYouTube', {});
   }
}

ng.module('e360').service('campaignsApi', CampaignsApi);
